import DiscountMessage from '../DiscountMessage';
import DesktopHeader from './DesktopHeader';
import Footer from './Footer';
import LayoutImage from './LayoutImage';
import MainContent from './MainContent';
import type { LayoutProps } from './types';

const DesktopLayout = ({
  children,
  currentStep,
  hasEyebrow,
  inverseHeader,
  isAccessory,
  isOuraRing4Wizard,
  itemCountForIcon,
}: LayoutProps) => {
  const marginTop = hasEyebrow ? '7rem' : '4.5rem';

  return (
    <div
      className="hidden h-screen max-h-screen w-screen max-w-[100vw] overflow-hidden bg-sandstone-100 lg:block"
      data-cy="wizard-desktop-layout"
    >
      <DiscountMessage />
      <DesktopHeader
        hasEyebrow={hasEyebrow}
        inverseHeader={inverseHeader}
        isAccessory={isAccessory}
        isOuraRing4Wizard={isOuraRing4Wizard}
        itemCountForIcon={itemCountForIcon}
      />

      <MainContent>
        <div className="flex h-screen">
          <div className="relative top-0 z-10 aspect-[2/1.69] h-full max-h-screen w-[calc(100vw-31rem)] max-w-[calc(100vw-31rem)] bg-gray-150">
            <LayoutImage
              currentStep={currentStep}
              isAccessory={isAccessory}
              isOuraRing4Wizard={isOuraRing4Wizard}
            />
          </div>
          <div className="relative z-10">
            <div className="flex h-screen w-[31rem] shrink-0 grow-0 flex-col">
              <div
                className="mb-[84px] grow overflow-y-scroll p-4"
                data-cy="desktop-layout-content"
                style={{
                  marginTop,
                }}
              >
                {children}
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </MainContent>
    </div>
  );
};

export default DesktopLayout;
